import React from 'react';
import { Section } from '@antonpodolsky/design-system/regions/section/section';
import { NumberedList } from '@antonpodolsky/design-system/data-display/numbered-list/numbered-list';
import { NumberedListItem } from '@antonpodolsky/design-system/data-display/numbered-list-item/numbered-list-item';

export const HomepageHowItWorks = () => (
  <Section width="sm" compact title="How Exify works?">
    <NumberedList>
      <NumberedListItem title="Hover over an image" titleInline>
        Exify is triggered automatically for images with a long side of 500px or
        more.
      </NumberedListItem>

      <NumberedListItem title="View data instantly" titleInline>
        A curated selection of EXIF properties is displayed in a sleek overlay
        for images with embedded EXIF metadata.
      </NumberedListItem>

      <NumberedListItem title="Check Content Credentials" titleInline>
        A badge displays verification status and certificate issuer for images
        with embedded C2PA credentials.
      </NumberedListItem>

      <NumberedListItem title="Explore full metadata" titleInline>
        Click the Exify logo or right-click the image and select &quot;Show
        EXIF&quot; to view and search all EXIF properties plus additional C2PA
        information.
      </NumberedListItem>
    </NumberedList>
  </Section>
);
